import { gutters } from 'app/spacing';

export const styles = `
  .Login-help {
    margin-top: ${gutters.standard};
    display: block;
    text-align: right;
  }
`;
